import {useCallback} from 'react';

export default function useWipeData() {
    return useCallback(async (onComplete) => {
        try {
            // Deregistra tutti i Service Worker
            if ('serviceWorker' in navigator) {
                const registrations = await navigator.serviceWorker.getRegistrations();
                for (const registration of registrations) {
                    await registration.unregister();
                }
            }

            // Cancella tutte le cache
            if ('caches' in window) {
                const cacheNames = await caches.keys();
                await Promise.all(
                    cacheNames.map((cacheName) => caches.delete(cacheName))
                );
            }

            // Cancella tutti i cookie accessibili da JS
            document.cookie.split(';').forEach((cookie) => {
                const eqPos = cookie.indexOf('=');
                const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
            });

            // Cancella localStorage e sessionStorage
            localStorage.clear();
            sessionStorage.clear();

            // Cancella IndexedDB
            if (window.indexedDB && indexedDB.databases) {
                const databases = await window.indexedDB.databases();
                await Promise.all(
                    databases.map(db => window.indexedDB.deleteDatabase(db.name))
                );
            }

            if (typeof onComplete === 'function') {
                onComplete();
            }
        } catch (error) {
            console.error('Errore durante il reset della PWA:', error);
        }
    }, []);
}
